import { render, staticRenderFns } from "./navigation-section-header.vue?vue&type=template&id=edc80508&"
import script from "./navigation-section-header.vue?vue&type=script&lang=ts&"
export * from "./navigation-section-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports